const quickLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Projects", href: "/urbaninfra" },
  { label: "Gallery", href: "/gallery" },
  { label: "Contact", href: "/contact" },
];

const projectLinks = [
  { label: "Sai Meadows Phase I", href: "/urbaninfra" },
  { label: "Sai Meadows Phase II", href: "/urbaninfra" },
  { label: "Sai Meadows Phase III", href: "/urbaninfra" },
  { label: "Anaaya Bliss", href: "/urbaninfra" },
  { label: "Urban Meadows", href: "/urbaninfra" },
  { label: "Green Earth", href: "/urbaninfra" },
  { label: "Urban Nest", href: "/urbaninfra" },
  { label: "Amber Park", href: "/urbaninfra" },
  { label: "Urban Palms", href: "/urbaninfra" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-[#1B2A4A] text-white">
      {/* Green accent line */}
      <div className="h-1 bg-[#7FBF3F]"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/c7ae924d-50ae-40da-8941-7a6efd15d389_IMG_2075.png?v=dd78fab24311a0791732f8670368f09b"
              alt="Urban Infra Logo"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Karnataka&apos;s trusted real estate developer — delivering eco-friendly villa plots and gated community layouts since 2016.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-facebook-fill", href: "#" },
                { icon: "ri-instagram-line", href: "#" },
                { icon: "ri-youtube-line", href: "#" },
              ].map((s) => (
                <a key={s.icon} href={s.href} rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full hover:bg-[#7FBF3F] hover:border-[#7FBF3F] transition-all duration-300 cursor-pointer">
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm text-white mb-4">Quick Links</h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/60 text-sm hover:text-[#7FBF3F] transition-colors cursor-pointer flex items-center gap-1.5">
                    <i className="ri-arrow-right-s-line text-[#7FBF3F] text-xs"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Projects */}
          <div>
            <h4 className="font-semibold text-sm text-white mb-4">Our Projects</h4>
            <ul className="flex flex-col gap-2">
              {projectLinks.map((p) => (
                <li key={p.label}>
                  <a href={p.href} className="text-white/60 text-xs hover:text-[#7FBF3F] transition-colors cursor-pointer flex items-center gap-1.5">
                    <i className="ri-arrow-right-s-line text-[#7FBF3F] text-xs"></i>
                    {p.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm text-white mb-4">Contact Us</h4>
            <div className="flex flex-col gap-3 mb-5">
              <a href="tel:+919945124133" className="flex items-start gap-2.5 text-white/60 text-sm hover:text-[#7FBF3F] transition-colors cursor-pointer">
                <i className="ri-phone-line text-[#7FBF3F] mt-0.5 flex-shrink-0"></i>
                +91 99451 24133
              </a>
              <a href="tel:08027822444" className="flex items-start gap-2.5 text-white/60 text-sm hover:text-[#7FBF3F] transition-colors cursor-pointer">
                <i className="ri-phone-line text-[#7FBF3F] mt-0.5 flex-shrink-0"></i>
                080 27822444
              </a>
              <a href="mailto:sales@urbaninfraproject.in" className="flex items-start gap-2.5 text-white/60 text-sm hover:text-[#7FBF3F] transition-colors cursor-pointer">
                <i className="ri-mail-line text-[#7FBF3F] mt-0.5 flex-shrink-0"></i>
                sales@urbaninfraproject.in
              </a>
              <div className="flex items-start gap-2.5 text-white/60 text-sm">
                <i className="ri-map-pin-line text-[#F36F21] mt-0.5 flex-shrink-0"></i>
                <span>#2, CNR Complex, First Floor, Muthanallur Cross, Sarjapur Main Road, Bangalore – 562125</span>
              </div>
              <div className="flex items-start gap-2.5 text-white/60 text-sm">
                <i className="ri-time-line text-[#7FBF3F] mt-0.5 flex-shrink-0"></i>
                11:00 AM – 7:00 PM
              </div>
            </div>
            <a
              href="https://wa.me/919945124133?text=Hi%2C%20I%27m%20interested%20in%20your%20plots.%20Please%20share%20details."
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap w-fit"
            >
              <i className="ri-whatsapp-line"></i>
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} Urban Infra. All rights reserved. | Karnataka, India
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/40 text-xs hover:text-[#7FBF3F] transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-white/40 text-xs hover:text-[#7FBF3F] transition-colors cursor-pointer">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
